import styled from "styled-components";

export const StyledAndroidIdentifiersFilter = styled.div`
    width: 263px;
`;
